import { Badge } from "@/components/ui";
import { Button } from "@/components/ui/Button";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/Select";
import { BodyText } from "@/components/ui/Text";
import { useState } from "react";
import type { CodifiedAllergen } from "./useAmazonVisitIntake";

export const CiqAllergyPopover = ({
  allergens,
  onAdd,
  isPending,
  addedAllergen,
  pendingAllergenName,
  addedLabel = "Added",
}: {
  allergens: CodifiedAllergen[];
  onAdd: (allergen: CodifiedAllergen) => void;
  isPending: boolean;
  addedAllergen?: CodifiedAllergen;
  pendingAllergenName?: string;
  addedLabel?: string;
}) => {
  const [value, setValue] = useState("");

  if (isPending) {
    return (
      <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 h-8 border border-transparent rounded-lg">
        <BodyText size="sm">{pendingAllergenName}</BodyText>
        <Button
          size="xs"
          type="button"
          isLoading={true}
          className="shrink-0 transition-none bg-button-superclinical text-button-primary border border-ai"
        >
          Add
        </Button>
      </div>
    );
  }

  if (addedAllergen) {
    return (
      <div className="mt-1 flex items-center justify-between gap-2 w-full px-2 h-8 border border-transparent rounded-lg">
        <BodyText size="sm">{addedAllergen.name ?? ""}</BodyText>
        <div className="flex items-center shrink-0" style={{ height: 25 }}>
          <Badge variant="ai">
            <BodyText size="xs">{addedLabel}</BodyText>
          </Badge>
        </div>
      </div>
    );
  }

  return (
    <Select
      value={value}
      onValueChange={(allergenId) => {
        setValue("");
        const allergen = allergens.find(
          (a) => String(a.allergenId) === allergenId,
        );
        if (allergen) onAdd(allergen);
      }}
    >
      <SelectTrigger className="mt-1">
        <SelectValue placeholder="Select to add..." />
      </SelectTrigger>
      <SelectContent scrollMode="scrollbar">
        {allergens.map((allergen) => (
          <SelectItem
            key={String(allergen.allergenId)}
            value={String(allergen.allergenId)}
          >
            {allergen.name ?? ""}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
